import { Tooltip } from "antd";

import StarCardIcon from "@/assets/icons/star_card.svg?react";

type WorkspaceButtonProps = {
  workspaceId?: number;
  workspaceName?: string;
  isDefault?: boolean;
  onClick?: () => void;
};

export function WorkspaceButton({
  workspaceId,
  workspaceName,
  isDefault = false,
  onClick,
}: WorkspaceButtonProps) {
  return (
    <Tooltip title="Manage workspaces">
      <button
        data-testid="workspace-button"
        data-workspace-id={workspaceId ?? ""}
        data-workspace-title={workspaceName ?? ""}
        data-workspace-default={isDefault ? "true" : "false"}
        onClick={onClick}
        className="bg-white h-fit py-[6px] text-[#064C68] px-2 rounded-md border border-[#E0E0E0] flex items-center gap-[6px] font-bold"
      >
        <StarCardIcon className="text-[#4A9CB8]" />
        <span>{workspaceName || "Default"}</span>
      </button>
    </Tooltip>
  );
}
